import { render, staticRenderFns } from "./ThankYouView.vue?vue&type=template&id=9e404ba0"
import script from "./ThankYouView.vue?vue&type=script&lang=js"
export * from "./ThankYouView.vue?vue&type=script&lang=js"
import style0 from "./ThankYouView.vue?vue&type=style&index=0&id=9e404ba0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports